import React, { useRef } from "react";
import PropTypes from "prop-types";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import AppBar from "@mui/material/AppBar";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

function TabPanel({ children, value, index }) {
  return (
    <div role="tabpanel" hidden={value !== index} id={`full-width-tabpanel-${index}`} aria-labelledby={`full-width-tab-${index}`}>
      {value === index && (
        <Box>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export default function CustomTab({
  tabs,
  initialIndex = 0,
  onTabChange,
  changeTab = () => { },
  sx,
  refresh,
  setRefresh,
  onUnreadClick = () => { },
  onRefreshClick = () => { },
}) {
  const theme = useTheme();
  const [value, setValue] = React.useState(initialIndex);
  const prevValueRef = useRef(null);

  const handleChange = (event, newValue) => {
    prevValueRef.current = value;
    if (newValue === 2) {
      if (onUnreadClick) {
        onUnreadClick();
      }
      return;
    }
    if (newValue === 3) {
      if (onRefreshClick) {
        onRefreshClick();
      } else if (setRefresh) {
        setRefresh(!refresh);
      }
      return;
    }
    setValue(newValue);
    changeTab(newValue);
    if (onTabChange) {
      onTabChange(newValue);
    }
  };

  return (
    <Box sx={{ bgcolor: "background.paper", width: "100%", ...sx }}>
      <AppBar
        position="sticky"
        sx={{
          boxShadow: "none",
          backgroundColor: "white",
          top: 50,
          zIndex: 1000,
          paddingBottom: "6px",
          paddingTop: "4px",
          overflow: "visible",
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          textColor="inherit"
          aria-label="customizable tabs"
          TabIndicatorProps={{ style: { display: "none" } }}
          sx={{
            backgroundColor: "white",
            boxShadow: "none",
            borderBottom: "none",
            minHeight: "36px",
            overflow: "visible",
            "& .MuiTabs-scroller": {
              overflow: "visible !important",
            },
            "& .MuiTabs-flexContainer": {
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              boxShadow: "none",
              borderBottom: "none",
              gap: "4px",
              overflow: "visible",
            },
          }}
        >
          {tabs.map((tab, index) => (
            <Tab
              key={index}
              label={tab.label}
              disableRipple={index >= 2}
              {...a11yProps(index)}
              sx={{
                flexShrink: 0,
                flexGrow: 0,
                padding: index === 3 ? "4px 4px" : "6px 12px",
                fontSize: "13px",
                fontWeight: "500",
                textTransform: "none",
                minHeight: "32px",
                height: "32px",
                minWidth: index === 3 ? "28px" : "auto",
                maxWidth: "none",
                whiteSpace: "nowrap",
                borderRadius: "6px",
                overflow: "visible",
                color: value === index && index < 2 ? "#ffffff !important" : "#000000 !important",
                backgroundColor: value === index && index < 2 ? "#5CB85C" : "transparent",
                boxShadow: "none",
                border: "none",
                lineHeight: 1.2,
                "&.Mui-selected": {
                  color: index < 2 ? "#ffffff !important" : "#000000 !important",
                },
                "&:not(.Mui-selected)": {
                  color: "#000000 !important",
                },
                "&.MuiTab-root": {
                  opacity: 1,
                  overflow: "visible",
                  whiteSpace: "nowrap",
                },
              }}
            />
          ))}
        </Tabs>
      </AppBar>

      {tabs.map((tab, index) =>
        tab.content ? (
          <TabPanel key={index} value={value} index={index} dir={theme.direction}>
            {tab.content}
          </TabPanel>
        ) : null
      )}
    </Box>
  );
}

CustomTab.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node.isRequired,
      content: PropTypes.node,
    })
  ).isRequired,
  initialIndex: PropTypes.number,
  onTabChange: PropTypes.func,
  sx: PropTypes.object,
  onUnreadClick: PropTypes.func,
};

